import React, { useEffect, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import CardForm from '../components/CardForm/CardForm';

export default function AddCardPage() {
  const [modalUrl, setModalUrl] = useState(null);

  // --- Read token from path ---
  const [params] = useSearchParams();
  const location = useLocation();

  // --- Read query params ---
  const queryParams = new URLSearchParams(location.search);
  const userIdUrl = queryParams.get("userId") || "";
  const orderIdUrl = queryParams.get("orderId") || "";
  const mobileUrl = queryParams.get("mobNo") || "";
  const returnUrl = queryParams.get("returnUrl") || "";

  // --- Fallback: if token missing in params, parse pathname manually ---

  const finalToken =
    params.get("q") ||
    params.get("token") ||
    null;

  // console.log("Token:", finalToken);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.type === 'CLOSE_IFRAME_AND_REDIRECT') {
        setModalUrl(null);
        window.location.href = event.data.path;
        console.log('Received postMessage:', event.data);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  const handleSubmit = (responseData) => {
    console.log('Card API Response:', responseData);
    if (responseData?.url) {
      setModalUrl(responseData.url);
    }
  };
 
  return (
    <div className="min-h-screen bg-gray-100 py-0 sm:py-16 relative">
      <CardForm
        userId={userIdUrl}
        objectReferenceId={orderIdUrl}
        mobileNumber={mobileUrl}
        returnUrl={returnUrl}
        token={finalToken}
        handleSubmit={handleSubmit}
      />
      {modalUrl && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-lg overflow-hidden w-full max-w-4xl h-[80vh] relative">
            <button
              onClick={() => setModalUrl(null)}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-800 text-xl font-bold"
            >
            </button>
            <iframe
              src={modalUrl}
              title="Payment Verification"
              className="w-full h-full border-none"
              allow="payment"
              ref={(iframe) => {
                if (iframe) {
                  iframe.onload = () => {
                    try {
                      const currentUrl = iframe.contentWindow.location.href;
                      if (currentUrl.includes('/payment-success')) {
                        // console.log('Redirect detected inside iframe, closing iframe and redirecting...');
                        setModalUrl(null);
                        window.location.href = currentUrl;
                      }
                    } catch (error) {}
                  };
                }
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}
